<template>

  <div class="box-title">
    <div class="container">
      <div class="row row-responsive -vertical-align">
        <div class="column column-xs-100 column-sm-50">
          <h1 class="maintitle">{{ title }}</h1>
        </div>
        <div class="column column-xs-100 column-sm-50">
          <p class="legend">{{ description }}</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'SidnedTitle',
  data () {
    return {
    }
  },
  props: ['title', 'description']
}

</script>

<style lang="scss" scoped>

.box-title {
  padding: 4rem 0 2rem;
  border-bottom: 1px solid $grey;

  .maintitle {
    margin: 0;
    font-size: 2.6em;
  }

  .legend {
    margin: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SignedTitle.vue